import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    loading: true,
    sections: []
  },
  mutations: {
    SET_INTERFACE_SETTINGS_LOADING(state, payload) {
      state.loading = payload
    },
    SET_INTERFACE_SETTINGS_SECTIONS(state, payload) {
      // const general_section = {
      //   id: 6,
      //   device_id: 2,
      //   section_id: 1,
      //   title: 'General Section',
      //   description: 'General Components',
      //   components: [{ title: 'Idle Screen', description: 'This is Testing Information', is_enable: false }]
      // }

      // state.sections = [...payload, general_section]

      // const idle_screen = {
      //   title: 'Idle Screen',
      //   description: 'Image or Video to display when the device is not in use'
      // }
      // state.sections = [...payload, idle_screen]

      state.sections = payload
    }
  },
  actions: {
    async fetchSectionList({ commit }) {
      try {
        commit('SET_INTERFACE_SETTINGS_SECTIONS', [])
        commit('SET_INTERFACE_SETTINGS_LOADING', true)
        const response = await api.getSectionList()
        if (response.data.success) {
          commit('SET_INTERFACE_SETTINGS_SECTIONS', response.data.data)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_INTERFACE_SETTINGS_LOADING', false)
      }
    },
    async updateSectionComponent({ commit }, payload) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.updating', ''), loading: true })
        const response = await api.updateSection({ params: payload })
        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.update', ''), icon: 'check', timeout: '2000' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    }
  }
}
